import { useCallback, useState } from 'react';
import { isAxiosError } from 'axios';
import { useIntl } from 'react-intl';

import { toastStore } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import Card from '@luna-protocol/core/src/components/Card/Card';
import CardRow from '@luna-protocol/core/src/components/CardRow/CardRow';
import Button from '@luna-protocol/core/src/components/Button/Button';
import useToast from '@luna-protocol/core/src/utils/useToast.ts';
import { postResendIdv } from '../../queries/usePostResendIdv';
import messages from './PlaidStatus.messages';
import styles from './PlaidStatus.module.scss';

type PlaidStatusProps = {
  className?: string;
};

const PlaidStatus = ({ className }: PlaidStatusProps) => {
  const { loan_application_id: loanApplicationID } = useParams();
  const { createToast } = useToast();
  const [pending, setPending] = useState(false);
  const { formatMessage } = useIntl();
  const toastPro = toastStore;

  const onResendIdentityVerificationClick = useCallback(() => {
    setPending(true);
    if (loanApplicationID) {
      postResendIdv(loanApplicationID)
        .then(() => {
          if (!toastPro.isActive('resend-idv-success')) {
            createToast({
              title: formatMessage(messages.resendIdentityVerificationSuccess),
              status: 'success',
              isClosable: true,
              duration: null,
              id: 'resend-idv-success',
            });
          }
          setPending(false);
        })
        .catch(error => {
          setPending(false);
          if (isAxiosError(error)) {
            if (!toastPro.isActive('resend-idv-error')) {
              createToast({
                title: error.response?.data?.error,
                status: 'error',
                isClosable: true,
                duration: null,
                id: 'resend-idv-error',
              });
            }
          }
        });
    }
  }, [loanApplicationID, toastPro, createToast, formatMessage]);

  return (
    <div className={className}>
      <p className={styles.plaidStatus__textCenter}>
        {formatMessage(messages.title)} - {formatMessage(messages.disabled)}
      </p>
      <Card>
        <CardRow label="Status" value="" />
        <Button
          type="button"
          variant="secondary"
          pending={pending}
          onClick={onResendIdentityVerificationClick}
          disabled={true}>
          {formatMessage(messages.resendIdentityVerificationButton)}
        </Button>
        <p className={styles.plaidStatus__textCenter}>{formatMessage(messages.description)}</p>
      </Card>
    </div>
  );
};

export default PlaidStatus;
